module.exports = __webpack_public_path__ + "img/mrsmith-mobile.8814dffa.webp";